<template>
	<div class="information">
		<div
			class="information-name"
			:style="`color:${$appColors.primary};border-bottom:1px solid ${$appColors.gray}`"
		>{{ data.name || name }}</div>
		<div
			class="information-title"
			:style="`color:${$appColors.primary};border-bottom:1px solid ${$appColors.gray}`"
		>{{ title }}</div>
		<div
			v-html="data.description || description"
			class="information-text"
			:style="`color:${$appColors.info}`"
		></div>
	</div>
</template>
<script>
export default {
	name: 'information',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		title: String,
		description: String,
		name: String,
	},
};
</script>
<style lang="scss" scoped>
	.information {
		&-name {
			font-family: map-get($fonts, bold);
			font-size: 14px;
			padding: 17px 0 24px;
			text-align: center;
			text-transform: uppercase;
		}

		&-title {
			font-size: 12px;
			padding: 10px 0;
			text-align: center;
			text-transform: uppercase;
		}

		&-text {
			font-size: 12px;
			padding: 24px 44px;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/information.vue